module.exports = __webpack_public_path__ + "img/alert-red.fd33dbbf.svg";